import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { ListPaginated } from '@febos-io/design';
import { ListFilter } from '@febos-io/common';

import { useCompanyListCallback } from '../hooks';

const LIMIT = 10;

export function CompanyList({
  HeaderComponent,
  RowComponent,
  configEnabledFilters,
  configFixedFilters,
  AddNewButton,
}) {
  const [page, setPage] = useState(0);
  const [actualFilters, setActualFilters] = useState('');

  const {
    loading,
    elements,
    meta: {
      pages,
    },
    callback,
  } = useCompanyListCallback(LIMIT);

  const handlerFilter = useCallback(
    (filter) => {
      setActualFilters(filter);
      setPage(1);
    },
    [setActualFilters]
  );

  useEffect(() => {
    if (page > 0) {
      callback(actualFilters, page);
    }
  }, [callback, page, actualFilters]);

  return (
    <>
      <div className="row justify-content-between">
        <div className="col-9">
          <span>
            <ListFilter
              configEnabledFilters={configEnabledFilters}
              configFixedFilters={configFixedFilters}
              onFilter={handlerFilter}
              contentFilter="search"
            />
          </span>
        </div>
        {AddNewButton && (
          <div className="col-2 text-end">
            <AddNewButton
              roles={['superadmin', 'support', 'admin']}
              to="/companies/new"
              title="New Company"
            />
          </div>
        )}
      </div>
      <ListPaginated
        HeaderComponent={HeaderComponent}
        RowComponent={RowComponent}
        currentPage={page}
        onPageChange={setPage}
        pages={pages}
        loading={loading}
        elements={elements}
        identifier="companyId"
      />
    </>
  );
}

CompanyList.propTypes = {
  HeaderComponent: PropTypes.elementType,
  RowComponent: PropTypes.elementType.isRequired,
  configEnabledFilters: PropTypes.object,
  configFixedFilters: PropTypes.object,
  AddNewButton: PropTypes.elementType,
};

export default CompanyList;
